import invariant from "tiny-invariant";

/**
 * Finds the first index in itemSizes where itemSizes[index].prevHeight >= targetHeight.
 * If all prevHeight values are less than targetHeight, returns itemSizes.length.
 */
export function binarySearchByPrevHeight(
  itemSizes: { prevHeight: number; height: number }[],
  lowIndex: number,
  highIndex: number,
  targetHeight: number,
): number {
  if (itemSizes.length === 0) {
    return -1;
  }

  invariant(lowIndex >= 0 && highIndex < itemSizes.length);
  while (lowIndex < highIndex) {
    const midIndex = (lowIndex + highIndex) >> 1;

    const prevItemHeight = itemSizes[midIndex]?.prevHeight;
    if (prevItemHeight === undefined || prevItemHeight < targetHeight) {
      lowIndex = midIndex + 1;
    } else {
      highIndex = midIndex;
    }
  }

  return lowIndex;
}
